/* global modForm modUtils */
import { capitalize } from '../../../helpers';
/**
 * Update project class dropdown if there's a trade specified on the url with the ?trade param
 */
export function populateTradeFromURL() {
	const queryParamString = modUtils.getUrlParamsToObject();
	const tradeSlug = queryParamString?.trade?.toLowerCase();
	const $primaryProjectClass = modForm.opts.form.querySelector('select[name="primaryProjectClass"]');

	if (tradeSlug && $primaryProjectClass) {
		const trade = capitalize(tradeSlug.replace(/-/g, ' ')).trim();
		$primaryProjectClass.querySelectorAll('option').forEach(function(option) {
			if (option.text === trade || option.getAttribute('data-qs-trade') === tradeSlug) {
				option.selected = true;
			}
		});
	}
}
